// Angular imports
import { Component, Input, OnInit } from '@angular/core';

// cc-common imports
import { Utils } from 'cc-common';

// Service imports
import { DetailPopupsService } from '../_services/detail-popups.service';

// Model imports
import { APBillParameterDto } from '../_models/accounts-payable/ap-bill/ap-bill-parameter-dto';
import { APPaymentParameterDto } from '../_models/accounts-payable/ap-payment/ap-payment-parameter-dto';
import { APAdjustmentParameterDto } from '../_models/accounts-payable/ap-adjustment/ap-adjustment-parameter-dto';
import { ARInvoiceDetailParameterDto } from '../_models/account-receivable/ar-invoice/ar-invoice-detail-parameter-dto';
import { ARAdjustmentParameterDto } from '../_models/account-receivable/ar-adjustment/ar-adjustment-parameter-dto';
import { CashReceiptParametersDto } from '../_models/cash-management/cash-receipts/cash-receipt-parameters-dto';
import { DepositParametersDto } from '../_models/cash-management/deposits/deposit-parameters-dto';
import { BatchParametersDto } from '../_models/cb-batches/batch-parameters-dto';
import { JournalEntryDetailParameterDto } from '../_models/general-ledger/journal-entry/journal-entry-detail-parameter-dto';
import { CashReceiptResultDto } from '../_models/cash-management/cash-receipts/cash-receipt-result-dto';
import { GLBatchSummaryParametersDto } from '../_models/general-ledger/gl-batch/gl-batch-summary-parameters-dto';

@Component({
    selector: 'app-detail-popups',
    templateUrl: './detail-popups.component.html',
    styleUrls: ['./detail-popups.component.scss']
})
export class DetailPopupsComponent implements OnInit {
    @Input() isCorporateCirabook = false;

    apBillDetailVisible = false;
    apBillDetailParam: APBillParameterDto;

    apPaymentDetailVisible = false;
    apPaymentDetailParam: APPaymentParameterDto;

    apAdjustmentDetailVisible = false;
    apAdjustmentDetailParam: APAdjustmentParameterDto;

    arInvoiceDetailVisible = false;
    arInvoiceDetailParam: ARInvoiceDetailParameterDto;

    arPaymentDetailVisible = false;
    arPaymentDetailParam: APPaymentParameterDto;

    arAdjustmentDetailVisible = false;
    arAdjustmentDetailParam: ARAdjustmentParameterDto;

    cashReceiptDetailVisible = false;
    cashReceiptDetailParam: CashReceiptParametersDto;

    depositDetailVisible = false;
    depositDetailParam: DepositParametersDto;

    batchDetailVisible = false;
    batchDetailParam: BatchParametersDto;

    jeDetailVisible = false;
    jeDetailParam: JournalEntryDetailParameterDto;

    cashReceiptEditorVisible = false;
    cashReceiptReverseEditorVisible = false;
    cashReceiptEditorParam: {
        title: string;
        cashReceiptResult: CashReceiptResultDto;
        cashReceiptParam: CashReceiptParametersDto;
    };

    workflowDetailVisible = false;
    workflowDetailPopupTitle = '';
    workflowDetailUrl = null;
    loadingVisible = false;

    showWorkflowViewer = false;
    selectedWorkflowId = null;
    communityId = null;

    showGLBatchSummary = false;
    glBatchSummaryParam: GLBatchSummaryParametersDto;

    constructor(private readonly detailPopupsService: DetailPopupsService) {}

    ngOnInit(): void {
        this.detailPopupsService.getSubjectAPBillDetail().subscribe((param) => {
            if (!!param) {
                this.apBillDetailParam = param;
                this.apBillDetailVisible = true;
            }
        });

        this.detailPopupsService.getSubjectAPPaymentDetail().subscribe((param) => {
            if (!!param) {
                this.apPaymentDetailParam = param;
                this.apPaymentDetailVisible = true;
            }
        });

        this.detailPopupsService.getSubjectAPAdjustmentDetail().subscribe((param) => {
            if (!!param) {
                this.apAdjustmentDetailParam = param;
                this.apAdjustmentDetailVisible = true;
            }
        });

        this.detailPopupsService.getSubjectARInvoiceDetail().subscribe((param) => {
            if (!!param) {
                this.arInvoiceDetailParam = param;
                this.arInvoiceDetailVisible = true;
            }
        });

        this.detailPopupsService.getSubjectARPaymentDetail().subscribe((param) => {
            if (!!param) {
                this.arPaymentDetailParam = param;
                this.arPaymentDetailVisible = true;
            }
        });

        this.detailPopupsService.getSubjectARAdjustmentDetail().subscribe((param) => {
            if (!!param) {
                this.arAdjustmentDetailParam = param;
                this.arAdjustmentDetailVisible = true;
            }
        });

        this.detailPopupsService.getSubjectCashReceiptDetail().subscribe((param) => {
            if (!!param) {
                this.cashReceiptDetailParam = param;
                this.cashReceiptDetailVisible = true;
            }
        });

        this.detailPopupsService.getSubjectCashReceiptEditor().subscribe((param) => {
            if (!!param) {
                this.cashReceiptEditorParam = param;
                this.cashReceiptEditorVisible = true;
            }
        });

        this.detailPopupsService.getSubjectCashReceiptReverseEditor().subscribe((param) => {
            if (!!param) {
                this.cashReceiptEditorParam = param;
                this.cashReceiptReverseEditorVisible = true;
            }
        });

        this.detailPopupsService.getSubjectDepositDetail().subscribe((param) => {
            if (!!param) {
                this.depositDetailParam = param;
                this.depositDetailVisible = true;
            }
        });

        this.detailPopupsService.getSubjectBatchDetail().subscribe((param) => {
            if (!!param) {
                this.batchDetailParam = param;
                this.batchDetailVisible = true;
            }
        });

        this.detailPopupsService.getSubjectJournalEntryDetail().subscribe((param) => {
            if (!!param) {
                this.jeDetailParam = param;
                this.jeDetailVisible = true;
            }
        });

        this.detailPopupsService.getSubjectWorkflowDetail().subscribe((param) => {
            if (!!param) {
                this.workflowDetailPopupTitle = `Workflow Details - ${param.workflowId}`;
                this.workflowDetailVisible = true;
                setTimeout(() => {
                    const tokens = [`mode=popup`, `showFullFilters=false`];
                    if (!!param.managementCompanyId) {
                        tokens.push(`managementCompanyId=${param.managementCompanyId}`);
                    }
                    if (!!param.communityId) {
                        tokens.push(`communityId=${param.communityId}`);
                    }
                    if (!!param.workflowId) {
                        tokens.push(`workflowId=${param.workflowId}`);
                    }
                    if (!!param.vendorId) {
                        tokens.push(`vendorId=${param.vendorId}`);
                    }
                    this.workflowDetailUrl = `workflow/wfinvoices?${tokens.join('&')}`;
                }, 350);
            }
        });

        this.detailPopupsService.getSubjectWorkflowViewer().subscribe((param) => {
            if (!!param) {
                this.selectedWorkflowId = param.workflowId;
                this.communityId = param.communityId;
                this.showWorkflowViewer = true;
            }
        });

        this.detailPopupsService.getSubjectGLBatchSummary().subscribe((param) => {
            if (!!param) {
                this.glBatchSummaryParam = param;
                this.showGLBatchSummary = true;
            }
        });
    }

    onAPBillDetailClose(e: any): void {
        this.apBillDetailVisible = false;
        this.apBillDetailParam = null;
        if (Utils.isTrue(e)) {
            this.detailPopupsService.updateForceReload(e);
        }
    }

    onAPPaymentDetailClose(e: any): void {
        this.apPaymentDetailVisible = false;
        this.apPaymentDetailParam = null;

        if (Utils.isTrue(e)) {
            this.detailPopupsService.updateForceReload(e);
        }
    }

    onAPAdjustmentDetailClose(e: any): void {
        this.apAdjustmentDetailVisible = false;
        this.apAdjustmentDetailParam = null;
        if (Utils.isTrue(e)) {
            this.detailPopupsService.updateForceReload(e);
        }
    }

    onARInvoiceDetailClose(e: any): void {
        this.arInvoiceDetailVisible = false;
        this.arInvoiceDetailParam = null;
        if (Utils.isTrue(e)) {
            this.detailPopupsService.updateForceReload(e);
        }
    }

    onARInvoiceActivitySuccess(): void {
        this.detailPopupsService.updateForceReload(true);
    }

    onARPaymentDetailClose(e: any): void {
        this.arPaymentDetailVisible = false;
        this.arPaymentDetailParam = null;
        if (Utils.isTrue(e)) {
            this.detailPopupsService.updateForceReload(e);
        }
    }

    onARAdjustmentDetailClose(e: any): void {
        this.arAdjustmentDetailVisible = false;
        this.arAdjustmentDetailParam = null;
        if (Utils.isTrue(e)) {
            this.detailPopupsService.updateForceReload(e);
        }
    }

    onCashReceiptDetailClose(e: any): void {
        this.cashReceiptDetailVisible = false;
        this.cashReceiptDetailParam = null;
        if (Utils.isTrue(e)) {
            this.detailPopupsService.updateForceReload(e);
        }
    }

    onCashReceiptEditorClose(e: any): void {
        this.cashReceiptEditorVisible = false;
        this.cashReceiptReverseEditorVisible = false;
        this.cashReceiptEditorParam = null;
        if (Utils.isTrue(e)) {
            this.detailPopupsService.updateForceReload(e);
        }
    }

    onDepositDetailClose(e: any): void {
        this.depositDetailVisible = false;
        this.depositDetailParam = null;
        if (Utils.isTrue(e)) {
            this.detailPopupsService.updateForceReload(e);
        }
    }

    onBatchDetailClose(e: any): void {
        this.batchDetailVisible = false;
        this.batchDetailParam = null;
        if (Utils.isTrue(e)) {
            this.detailPopupsService.updateForceReload(e);
        }
    }

    onJEDetailClose(e: any): void {
        this.jeDetailVisible = false;
        this.jeDetailParam = null;
        if (Utils.isTrue(e)) {
            this.detailPopupsService.updateForceReload(e);
        }
    }

    onWorkflowDetailShown(e: any): void {
        this.loadingVisible = true;
        e.component.repaint();
    }

    onWorkflowDetailClose(e: any): void {
        this.workflowDetailVisible = false;
        this.loadingVisible = false;
        this.workflowDetailUrl = null;
        this.workflowDetailPopupTitle = '';

        if (Utils.isTrue(e)) {
            this.detailPopupsService.updateForceReload(e);
        }
    }

    onViewerClose(e: any): void {
        this.showWorkflowViewer = false;
        if (Utils.isTrue(e)) {
            this.detailPopupsService.updateForceReload(e);
        }
    }

    onWorkflowDetailLoad(e: any): void {
        setTimeout(() => (this.loadingVisible = false), 5000);
    }

    onGlBatchSummaryClose(e: any): void {
        this.showGLBatchSummary = false;
        this.glBatchSummaryParam = null;
        if (Utils.isTrue(e)) {
            this.detailPopupsService.updateForceReload(e);
        }
    }
}
